<div class="loading">
  <div class="loading__text">
    <ng-content select="[slot=start]"></ng-content>
  </div>
  <div class="loading__icon">
    <ion-spinner name="crescent" color=primary></ion-spinner>
  </div>
  <div class="loading__text">
    <ng-content select="[slot=end]"></ng-content>
  </div>
</div>